import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxForm, clearSubmitErrors } from 'redux-form';

import { compose } from 'redux';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';

import validate from './validations';

import {
    AddressPopupContainer,
    Title,
    FormGroup,
    MultipleGroup,
    ButtonGroup
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';

const Error = styled.span`
    font-family: Averta;
    font-size: 0.5em;
    font-weight: bold;
    line-height: 1.5;
    letter-spacing: 1px;
    text-align: right;
    color: #ff245e;
    text-transform: uppercase;
    float: right;
    margin-top: 8px;
`;

class AddressForm extends React.Component {
    render() {
        return (
            <AddressPopupContainer onSubmit={this.props.handleSubmit} autocomplete="on">
                <Title>
                    Voter Registration
                    {this.props.isErrorOnSubmit && (
                        <Error>An error occured. Please try again</Error>
                    )}
                </Title>
                <FormGroup>
                    <Field
                        name="postalCode"
                        component={InputGroup}
                        type="text"
                        label="POSTAL CODE"
                        placeholder="Postal Code"
                        autocomplete="off"
                        maxLength={5}
                        onChange={this.props.onPostalCodeChange}
                    />
                </FormGroup>
                <MultipleGroup>
                    <Field
                        name="month"
                        component={DropDownSelect}
                        options={this.props.month}
                        defaultOption={'Month'}
                        label="DATE OF BIRTH"
                        type="text"
                    />
                    <Field
                        name="day"
                        component={DropDownSelect}
                        options={this.props.day}
                        defaultOption={'Day'}
                        label=""
                        type="text"
                    />
                    <Field
                        name="year"
                        component={DropDownSelect}
                        options={this.props.year}
                        defaultOption={'Year'}
                        label=""
                        type="text"
                    />
                </MultipleGroup>
                <ButtonGroup isAddressSubmitting={this.props.isAddressSubmitting}>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <Button
                            primary={true}
                            label={'Submit'}
                            type="submit"
                            className="submitButton"
                            disabled={this.props.invalid}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </AddressPopupContainer>
        );
    }
}

AddressForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    onBack: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    isAddressSubmitting: PropTypes.bool,
    month: PropTypes.array,
    year: PropTypes.array,
    day: PropTypes.array,
    postalCode: PropTypes.string,
    onPostalCodeChange: PropTypes.func,
    isErrorOnSubmit: PropTypes.bool
};

export default compose(
    connect((state, props) => ({
        initialValues: {
            postalCode:
                props.postalCode ||
                (state.widget.endUserLocation || {}).postalCode ||
                state.cachedFormData.postalCode ||
                '',
            month: state.cachedFormData.month || '',
            day: state.cachedFormData.day || '',
            year: state.cachedFormData.year || ''
        }
    })),
    reduxForm({
        form: 'addressForm',
        onChange: (values, dispatch) => {
            dispatch(clearSubmitErrors('addressForm'));
        },
        destroyOnUnmount: false,
        validate
    })
)(AddressForm);



// WEBPACK FOOTER //
// ./src/components/VoteRegistration/AddressPopupForm.jsx